import React from 'react';
import { Link } from 'react-router-dom';
import Accordion from '../../components/public/Accordion';
import PageHero from '../../components/public/PageHero';
import PublicLayout from '../../components/public/PublicLayout';
import { admissionsFaqs, admissionsSteps } from '../../publicSite/admissionsContent';
import { APPLY_ROUTE, withBase } from '../../publicSite/config';
import { usePageMeta } from '../../publicSite/usePageMeta';

export default function Admissions() {
  usePageMeta(
    'Admissions | School of Shem',
    'Learn how to apply to School of Shem and move from registration to onboarding.'
  );

  return (
    <PublicLayout>
      <PageHero
        eyebrow="Begin your journey"
        title="Admissions"
        subtitle="A clear path from choosing your academic faculty to joining the School of SHEM learning community."
        image="/images/shem-mentorship.jpg"
        imageAlt="A School of SHEM mentor guiding a prospective learner"
        actions={(
          <>
            <Link to={withBase(APPLY_ROUTE)} className="btn btn-primary">Apply Now</Link>
            <Link to={withBase('/admissions/enquire')} className="btn btn-outline">Make an Enquiry</Link>
          </>
        )}
      />

      <div className="public-trust-strip" aria-label="Admissions highlights">
        <div><strong>13</strong><span>specialised faculties</span></div>
        <div><strong>01</strong><span>connected learning ecosystem</span></div>
        <div><strong>24–48h</strong><span>admissions response time</span></div>
      </div>

      <section className="ps-section">
        <div className="ps-section-inner">
          <div className="ps-hero-eyebrow">How to apply</div>
          <h2 className="ps-section-title">Three straightforward steps</h2>
          <div className="public-admissions-steps">
            {admissionsSteps.map((step, index) => (
              <article key={step.title}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="ps-section ps-section-muted">
        <div className="ps-section-inner public-faq-layout">
          <div>
            <div className="ps-hero-eyebrow">Good to know</div>
            <h2 className="ps-section-title">Admissions FAQs</h2>
            <p className="ps-section-copy">
              Find quick answers about registration, approval, payment, and intake dates.
            </p>
          </div>
          <Accordion items={admissionsFaqs} />
        </div>
      </section>

      <section className="ps-section public-cta">
        <div className="ps-section-inner public-cta-inner">
          <div>
            <h2>Still deciding?</h2>
            <p>Explore the academic faculties or speak with the admissions team.</p>
          </div>
          <div className="ps-hero-actions">
            <Link to={withBase('/academics/faculties')} className="btn btn-outline">Explore Academics</Link>
            <Link to={withBase('/admissions/enquire')} className="btn btn-primary">Make an Enquiry</Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
